// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"AuthorizeSettingsList_contentComponent__281cx","tableContainer":"AuthorizeSettingsList_tableContainer__3qbgy","root":"AuthorizeSettingsList_root__27W2C"};